import { Helmet } from "react-helmet-async";
import Sidebar from "../DesignSystem/Sidebar/Sidebar";
import "../../css/Checks/NewCheck.css";
import RadioButton from "../Components/Buttons/RadioButton";
import EnhancedCheck from "./Check/Enhanced";
import StandardCheck from "./Check/Standard";
import SimpleCheck from "./Check/Simple";
import PEPSanctionsCheck from "./Check/PEPSanctions";
import { useState, useEffect } from "react";
import { useUserEmail } from "../../context/UserEmailContext";
import { useUserRole } from "../../context/UserRoleContext";
// import { useUserPermissions } from "../../context/UserPermissionsContext";
import { useNavigate } from "react-router-dom";
// import { useAdminStatus } from "../../context/AdminStatusContext";
import Banner from "../Components/Banners/Banner";
// import { useAdminMails as useAdminAdviserMails } from "../../../context/AdminEmailsContext";
// import { useBranding } from "../../../../context/BrandingContext";
import { canSubmitSimpleCheck } from "./utils/helperFunctions/canSubmitSimpleCheck";
// import { canAccessAML } from "../Utils/permissions";
import { ReactComponent as Check2Logo } from "../../assets/icons/logo.svg";
import { ReactComponent as QuestionMark } from "../../assets/icons/question-mark-tooltip.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/information.svg";
import CheckHelpModal from "./Components/CheckHelpModal";
import { useCheck2GuideUrl } from "../Checks/utils/guide/getUrl";
import { isSimpleCheckUser } from "./utils/helperFunctions/isSimpleCheckUser";
import {
  CHECK_TYPES,
  useAllowedCheckTypes,
} from "./utils/hooks/useAllowedCheckTypes";
const NewCheck = () => {
  const [selectedCheck, setSelectedCheck] = useState(""); // default
  const { userEmail } = useUserEmail();
  const { userRole } = useUserRole();
  // const { userPermissions } = []; // useUserPermissions();
  const navigate = useNavigate();
  // const { adminStatus } = [];
  // const { currentAdviserEmail } = [];

  const [showCheckHelp, setShowCheckHelp] = useState(false);
  const [canSeeAML, setCanSeeAML] = useState(false);
  const check2GuideUrl = useCheck2GuideUrl();

  const [isSimpleUser, setIsSimpleUser] = useState(false);
  const [loadingSimpleUser, setLoadingSimpleUser] = useState(true);

  const { allowedChecks, loadingAllowedCheckTypes } = useAllowedCheckTypes();

  useEffect(() => {
    if (loadingAllowedCheckTypes) return;
    if (!allowedChecks.length) return;

    const currentAllowed = allowedChecks.some(
      (check) => check.label === selectedCheck,
    );

    if (!currentAllowed) {
      setSelectedCheck(allowedChecks[0].label);
    }
  }, [allowedChecks, loadingAllowedCheckTypes, selectedCheck]);

  useEffect(() => {
    const checkUser = async () => {
      try {
        if (!userEmail) {
          setIsSimpleUser(false);
          return;
        }

        const result = await isSimpleCheckUser(userEmail);
        setIsSimpleUser(result);
      } catch (err) {
        console.error("Failed to check simple check user", err);
        setIsSimpleUser(false);
      } finally {
        setLoadingSimpleUser(false);
      }
    };

    checkUser();
  }, [userEmail]);

  // const { tradingName } = "";

  // const canSubmit =
  //   !loadingSimpleUser &&
  //   (canSubmitSimpleCheck({
  //     userRole,
  //     userPermissions,
  //     tradingName,
  //   }) ||
  //     isSimpleUser);

  // useEffect(() => {
  //   let mounted = true;

  //   async function checkAccess() {
  //     const allowed = await canAccessAML({
  //       userRole,
  //       userPermissions,
  //       adminEmail: userEmail,
  //     });

  //     if (mounted) setCanSeeAML(allowed);
  //   }

  //   checkAccess();

  //   return () => {
  //     mounted = false;
  //   };
  // }, [userRole, userPermissions, userEmail]);

 const renderCheckComponent = () => {
   switch (selectedCheck) {
     case "Enhanced":
       return <EnhancedCheck />;

     case "Standard":
       return <StandardCheck />;

     case "Simple":
       return  <SimpleCheck />;

     case "PEP & Sanctions":
       return <PEPSanctionsCheck />;

     default:
       return null;
   }
 };

  // useEffect(() => {
  //   if (canSeeAML) {
  //     navigate("/MembersHub");
  //   }
  // }, [userEmail, navigate, userRole, userPermissions, adminStatus]);

  // const mustPickAdviser = isAdviserAdmin && !currentAdviserEmail;

  return (
    <div className="Main-Page">
      <Helmet>
        <title>
          {selectedCheck === "PEP & Sanctions"
            ? "PEP & Sanctions Check"
            : `${selectedCheck} Check`}
        </title>
        <meta name="description" content="New Check" />
      </Helmet>
      <Sidebar />
   
        <div className="new-aml-check-container">
          <div className="new-aml-check-logo-header">
            <Check2Logo />
            <div className="new-aml-check-helper-row">
              <div
                className="new-aml-check-logo-header"
                style={{ gap: "10px", cursor: "pointer" }}
                onClick={() => setShowCheckHelp(true)}
              >
                <div className="AML-Text-Body">Help</div>
                <QuestionMark className="InfoIcon" />
              </div>
              <div
                className="new-aml-check-logo-header"
                style={{
                  gap: "10px",
                  cursor: check2GuideUrl ? "pointer" : "not-allowed",
                  opacity: check2GuideUrl ? 1 : 0.5,
                }}
                onClick={() => {
                  if (!check2GuideUrl) return;
                  window.open(check2GuideUrl, "_blank", "noopener,noreferrer");
                }}
              >
                <div className="AML-Text-Body">Guide</div>
                <InfoIcon className="InfoIcon" />
              </div>
            </div>
          </div>
          <div className="new-aml-check-header">
            {/* <div className="AML-Text-Title">Select a Check</div> */}
            {/* {mustPickAdviser && (
            <Banner
              type="warning"
              message="Please select an adviser in the sidebar before creating a check."
            />
          )} */}

            <div className="new-aml-check-row">
              {allowedChecks.map((check) => {
                // if (check.key === CHECK_TYPES.SIMPLE && !canSubmit) return null;

                return (
                  <RadioButton
                    key={check.key}
                    label={check.label}
                    checked={selectedCheck === check.label}
                    onChange={() => setSelectedCheck(check.label)}
                  />
                );
              })}
            </div>
          </div>
          {selectedCheck !== "Simple" && (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setShowCheckHelp(true)}
            >
              <Banner
                type="warning"
                message="Unsure which check to select? Click here to help you decide."
              />
            </div>
          )}
          {/* {isAdviserAdmin && currentAdviserEmail && (
          <Banner
            type="warning"
            message={`This check is being requested on behalf of ${currentAdviserEmail}. Please ensure you have their consent before proceeding.`}
          />
        )} */}
          {renderCheckComponent()}
          {/* {!mustPickAdviser && renderCheckComponent()} */}
        </div>

        <CheckHelpModal
          open={showCheckHelp}
          onClose={() => setShowCheckHelp(false)}
          // canShowSimple={canSubmit}
        />
      </div>

  );
};
export default NewCheck;
